// extracted by mini-css-extract-plugin
export default {"grt-button":"style_grt-button__T9yyc"};